<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r">
      <v-toolbar class="primary mb-2 darken-2 card-r shadow-1 pl-3 text-white">
        <router-link to="/classes"><v-icon class="text-white pr-2 left">keyboard_arrow_left</v-icon></router-link>
        <div class="text-xs-left f-20">Edit : {{classTitle}}</div>
      </v-toolbar>
      <v-card class="pa-2 no-shadow grey lighten-5">
        <v-layout wrap >
          <v-flex lg4 xs12>
            <v-select solo
                      v-model="classType"
                      :items="types"
                      item-text="text"
                      item-value="value"
                      class="input-group--focused"
                      label="Class Type"
                      type="text"
            ></v-select>
          </v-flex>
          <v-flex lg4 xs12 v-if="classType=='other'">
            <v-text-field solo v-model="otherType" :rules="requiredRule" label="Type Class type"></v-text-field>
          </v-flex>
          <v-flex lg4 xs12>
            <v-text-field solo v-model="classTitle" :rules="requiredRule" label="Class Title"></v-text-field>
          </v-flex>
          <v-flex xs12 lg12 class="text-xs-left mb-3">
            <v-flex class="white shadow-1">
              <div class="text-xs-left text-primary ml-2 f-9">Description Tags</div>
              <treeselect placeholder=" Description tag" v-model="value" search-nested :always-open="false" :append-to-body="true" :multiple="true" :options="options" />
            </v-flex>
          </v-flex>
          <v-flex xs12 xs12 lg4 ><v-text-field
            solo v-model="classLocation" label="Class Location"></v-text-field></v-flex>


          <v-flex xs12 xs12 lg3 >
            <v-select
              solo
              v-model="classHours"
              :items="workMin"
              class="input-group--focused"
              label="Minutes (Class Minutes can add here)"
              type="number"
            ></v-select>

          </v-flex >
          <!-- <v-flex xs12 >
           <v-text-field v-model="classPrice" type="number"  label="Class Price"></v-text-field>
           </v-flex>
         <v-flex xs12 >
           <v-text-field v-model="internalPrice" type="number" label="Internal Price"></v-text-field>
         </v-flex> -->
          <!-- <v-flex lg12 sm12 xs12 class="pt-0 pb-0" >
            <v-menu
              ref="dialog1"
              :close-on-content-click="false"
              v-model="datePickMenu"
              :return-value.sync="classDate"
              lazy
              persistent
              full-width
              min-width="290px"
            >
              <v-text-field
                solo
                slot="activator"
                v-model="classDate"
                label="Date"
                placeholder="dd/mm/yyyy"
                solo
                readonly
                required
              ></v-text-field>
              <v-date-picker v-model="classDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="datePickMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog1.save(classDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex> -->
          <!-- <v-flex lg12 sm12 xs12>
              <v-autocomplete
                v-model="classTime"
                item-value="value"
                item-text="text"
                :items="timeslot"
                label="Time"
                placeholder="select your start time">
              </v-autocomplete>
          </v-flex> -->
          <v-flex xs12 lg12 class="pt-0 pb-0">
            <v-textarea solo class="redius-5" name="input-7-1" v-model="classDescription" label="Description" ></v-textarea>
          </v-flex>
          <v-flex xs12 lg12 class="pt-0 pb-0 hide-pro">
            <v-textarea solo class="redius-5" name="input-7-1" v-model="sms_content" label="Sms" ></v-textarea>
          </v-flex>
            <v-flex xs12 lg12 class="pt-0 pb-0 hide-pro">
            <v-textarea solo class="redius-5" name="input-7-1" v-model="email_content" label="Email" ></v-textarea>
          </v-flex>
          <v-flex>
            <v-checkbox
              class="pt-0 pb-0 mt-0 mb-0"
              v-model="unlimitedTick"
              label="Tick if you need unlimited number of booking"
            ></v-checkbox>

          </v-flex>
          <v-flex  xs12 lg4 v-for="img in images">
            <v-card flat tile flex>
              <v-img
                :src="img.image"
                style="height: 100px; width: 100px !important;"
                :lazy-src="img.image"
                aspect-ratio="1"
                class="grey lighten-2">
                <v-layout
                  slot="placeholder"
                  fill-height
                  align-center
                  justify-center
                  ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </v-img>
            </v-card>

          </v-flex>

          <v-flex xs12 class="text-xs-center">
            <v-alert
              v-if="alert.type=='success'"
              :value="true"
              color="success"
              icon="check_circle"
              outline
            >
              {{alert.msg}}
            </v-alert>
            <v-alert
              v-if="alert.type=='warning'"
              :value="true"
              color="error"
              icon="warning"
              outline
            >
              {{alert.msg}}
            </v-alert>
            <v-progress-circular
              indeterminate
              color="primary"
              v-if="loading"
            ></v-progress-circular>
          </v-flex>

          <v-flex xs12 class="text-xs-right">
            <ConfirmEdit v-bind:value1="classTitle" v-on:confirmyes="classEdit" v-bind:value2="internalPrice"/>
            <!-- <v-btn class="text-white card-r no-shadow" color="primary" @click="classEdit">Confirm</v-btn> -->
          </v-flex>
        </v-layout>
      </v-card>
    </v-card>
  </v-container>
</template>
<script>
  /* eslint-disable */
  import ConfirmEdit from "../auth/ConfirmEdit";
  import router from '@/router'
  import { mapState, dispatch } from "vuex";
  import Treeselect from '@riophae/vue-treeselect'
  import api from '../../utils/backend-api.js'

  // const id = $route.params.id;
  export default {
    name: "EditClass",

    data: () => ({
      id:'',
      classTitle:'',
      classLocation:'',
      classHours:'',
      classType:"",
      classPrice:'',
      internalPrice:'',
      //description:'',
      tags:'',
      classDescription:'',
      attachment: {
        galleries: [],
        galleryURL: [],
        photosURL: [],
        videos: [],
        videosURL: []
      },
      images:[],
      requiredRule: [v => !!v || "This field is required"],
      workMin: ["45", "90", "135", "180","225","270","315","360"],
      // types:['teori', 'kørsel', 'manøvre', 'glatbane', 'other'],
      types:[
        {text:'Teori',value:'teori'},
        {text:'Kørsel',value:'kørsel'},
        {text:'Manøvre',value:'manøvre'},
        {text:'Glatbane',value:'glatbane'},
        {text:'Other',value:'other'}
      ],
      otherType:'',
      options: [],
      value:[],
      tagId:{
        parent:[],
        child:[],
        childOfChild:[],
      },
      loading:false,
      alert:{
        type:'',
        msg:''
      },
      unlimitedTick:false,
      datePickMenu:false,
      timePickMenu:false,
      classDate:'',
      classTime:'',
      email_content:'',
      sms_content:'',
      timeslot: [
        {text:'07:00 am',value:'07:00'},
        {text:'07:30 am',value:'07:30'},
        {text:'08:00 am',value:'08:00'},
        {text:'08:30 am',value:'08:30'},
        {text:'09:00 am',value:'09:00'},
        {text:'09:30 am',value:'09:30'},
        {text:'10:00 am',value:'10:00'},
        {text:'10:30 am',value:'10:30'},
        {text:'11:00 am',value:'11:00'},
        {text:'11:30 am',value:'11:30'},
        {text:'12:00 pm',value:'12:00'},
        {text:'12:30 pm',value:'12:30'},
        {text:'01:00 pm',value:'13:00'},
        {text:'01:30 pm',value:'13:30'},
        {text:'02:00 pm',value:'14:00'},
        {text:'02:30 pm',value:'14:30'},
        {text:'03:00 pm',value:'15:00'},
        {text:'03:30 pm',value:'15:30'},
        {text:'04:00 pm',value:'16:00'},
        {text:'04:30 pm',value:'16:30'},
        {text:'05:00 pm',value:'17:00'},
        {text:'05:30 pm',value:'17:30'},
        {text:'06:00 pm',value:'18:00'},
        {text:'06:30 pm',value:'18:30'},
      ],
    }),
    created:function(){
      api.postData('tag/viewTag')
        .then(res=>{
          this.options=res.data
          this.storeTagId(res.data)
        }).catch(err=>{

      })
    },
    // watch: {},
    mounted() {

      this.adminId = this.$route.params.id;
      Store.dispatch("Modules/getClassById", this.adminId).then(res => {
      });
      setTimeout(() => {
        this.classTitle =Store.state.Modules.singlemodule.name;
        this.classLocation =Store.state.Modules.singlemodule.location;
        this.classHours =Store.state.Modules.singlemodule.hours.toString();
        this.classPrice =Store.state.Modules.singlemodule.price;
        this.classType = Store.state.Modules.singlemodule.type;
        this.otherType = Store.state.Modules.singlemodule.other_type;
        this.internalPrice =Store.state.Modules.singlemodule.internal_price;
        this.tags =Store.state.Modules.singlemodule.tags;
        this.images =Store.state.Modules.singlemodule.image_count;
        this.classDescription = Store.state.Modules.singlemodule.description;
        this.sms_content=Store.state.Modules.singlemodule.sms_content
        this.email_content=Store.state.Modules.singlemodule.email_content
        let date
        if(Store.state.Modules.singlemodule.date!=null){
          date =Store.state.Modules.singlemodule.date;
        }else{
          date=null
        }
        this.classDate=date
        let time
        if(Store.state.Modules.singlemodule.time!=null){
          time=(Store.state.Modules.singlemodule.time).substring(0,5);
        }else{
          time=null
        }
        this.classTime =time
        let unlimitedTick =Store.state.Modules.singlemodule.booking_status;
        if(unlimitedTick=='limited'){
          this.unlimitedTick=false
        }else if(unlimitedTick=='unlimited'){
          this.unlimitedTick=true
        }
        let tempDesc=this.tags
        let value=[]
        tempDesc.forEach(function(element){
          value.push(element['id'])
        })
        this.value=value
        this.image =Store.state.Modules.singlemodule.images;
      }, 2500);
    },
    methods: {
      storeTagId(Tags){
        let parent=[]
        let child=[]
        let childOfChild=[]
        Tags.forEach(function(element,index){
          parent.push(element.id)
          if(Tags[index].children){
            let children=Tags[index].children
            children.forEach(function(elementC,indexC){
              child.push(children[indexC].id)

              if(Tags[index].children[indexC].children){
                // console.log(Tags[index].children[indexC].children)
                let childrenOfChild=Tags[index].children[indexC].children
                childrenOfChild.forEach(function(elementCC,indexCC){
                  childOfChild.push(childrenOfChild[indexCC].id)
                })
              }
            })
          }
        })
        this.tagId.parent=parent
        this.tagId.child=child
        this.tagId.childOfChild=childOfChild
      },
      TagIdAnalyze(tagIdList){
        let oldParent=this.tagId.parent
        let oldChild=this.tagId.child
        let oldchildOfChild=this.tagId.childOfChild
        let finalParent=[]
        let finalChild=[]
        let finalChildOfChild=[]
        console.log("tagIdList")
        console.log(tagIdList)
        tagIdList.forEach(function(element,index){
          console.log(element)
          oldParent.forEach(function(elementP,indexP){
            // console.log(elementP)
            if(elementP==element){
              finalParent.push(elementP)
            }
          })
          oldChild.forEach(function(elementC,indexC){
            if(elementC==element){
              finalChild.push(elementC)
            }
          })
          oldchildOfChild.forEach(function(elementCC,indexCC){
            if(elementCC==element){
              finalChildOfChild.push(elementCC)
            }
          })
        })

        return {
          finalParent,
          finalChild,
          finalChildOfChild
        };
      },
      classEdit(){
        this.loading=true
        var {finalParent,finalChild,finalChildOfChild}=this.TagIdAnalyze(this.value)
        var moduleDetails={
          'name':this.classTitle,
          'location':this.classLocation,
          'hours':this.classHours,
          'price':this.classPrice,
          'type':this.classType,
          // 'internal_price':this.internalPrice,
          'tags':this.tags,
          // 'gallery':this.attachment.galleries,
          // 'image_count':this.attachment.galleries.length
        }
        var formData = new FormData();
        formData.append("name", this.classTitle);
        formData.append("location", this.classLocation);
        formData.append("hours", this.classHours);
        formData.append("type", this.classType);
        formData.append("description", this.classDescription);
        formData.append("sms_content", this.sms_content);
        formData.append("email_content", this.email_content);
        if(this.classType=='other'){
          formData.append("other_type", this.otherType);
        }
        // formData.append("price", this.classPrice);
        // formData.append("internal_price", this.internalPrice);
        formData.append("tags", this.tags);
        // if(this.classDate){
        //   formData.append("date", this.classDate);
        // }
        if(this.classTime){
          formData.append("time", this.classTime);
        }
        // formData.append("parent[]", JSON.stringify(finalParent));
        if(finalParent && finalChild && finalChildOfChild){
          for (var x = 0; x < finalParent.length; x++) {
            formData.append("parent[]", finalParent[x]);
          }
          // formData.append("child", JSON.stringify(finalChild));
          for (var x = 0; x < finalChild.length; x++) {
            formData.append("child[]", finalChild[x]);
          }
          // formData.append("sub_child", JSON.stringify(finalChildOfChild));
          for (var x = 0; x < finalChildOfChild.length; x++) {
            formData.append("sub_child[]", finalChildOfChild[x]);
          }
          // for (var x = 0; x < this.attachment.galleries.length; x++) {
          //   formData.append("image"+x, this.attachment.galleries[x]);
          // }
        }
        let classLengthType
        if(this.unlimitedTick==true){
          classLengthType="unlimited"
        }else{
          classLengthType="limited"
        }

        // var count = this.attachment.galleries.length;
        // formData.append("image_count", count);
        formData.append("booking_status", classLengthType);

        var adminId=this.adminId
        var Data={
          "moduleDetails":formData,
          "adminId":this.adminId
        }

        // this.$store.commit('setLoading', { loading: true })
        api.postData('admin/module/' + Data.adminId, Data.moduleDetails).then(res => {
          console.log(res)
          if(res.status==201){
            this.loading=false
            this.alert.type='success'
            this.alert.msg='You have successfully updated'
            setTimeout(() => {
            this.loadClubClasses()
             }, 2000);
            router.push('/classes')
            window.location.reload()
      
           
            }  
          
          this.$store.dispatch('Modules/setModulesData',res.data)
        }).catch((error) => {
          this.loading=false
          this.alert.type='warning'
          this.alert.msg='Updation Failed.Check your details and try again'
        })
        // this.$store.dispatch('Modules/classEdit',Data).then(res=>{
        //   console.log(res)
        //   this.$store.commit('setLoading', { loading: false })

        // })
      },
      onPickImg(){
        this.$refs.ImgInput.click();
      },

       loadClubClasses(){
        let self=this
        api.getData('admin/module')
        // .then(res=>{
        //     self.$store.dispatch('setModulesData',res.data)
        // }).catch(err=>{
        //     self.$store.dispatch('setModulesData',[])
        // })
      },
      onImgPicked(){
        const files = event.target.files;
        if(files.length==1){
          this.attachment.galleries.push(files)
        }else{
          for(var i=0;i<files.length;i++){
            this.attachment.galleries.push(files[i])
          }
        }
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file! ");
        }
        for(var i=0;i<files.length;i++){
          const fileReader = new FileReader();
          fileReader.readAsDataURL(files[i]);
          fileReader.addEventListener("load", () => {
            this.attachment.galleryURL.push(fileReader.result);
          });
        }

      },
    },
    components: {
      ConfirmEdit,
      Treeselect
    },
    computed: {
      ...mapState({
        modules: Modules => Store.state.Modules.modules
      })
    },
  };
</script>
<style>
  .v-dialog{
    box-shadow: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/classes/EditClass.vue